type Step1DetailsProps = {
  numOfTransactions: number;
  numOfGroups: number;
};

function Step1Details({ numOfTransactions, numOfGroups }: Step1DetailsProps) {
  return (
    <div>
      <p>{`We've identified a discrepancy affecting ${numOfTransactions} ${
        numOfTransactions > 1 ? "transactions" : "transaction"
      } in ${numOfGroups} ${
        numOfGroups > 1 ? "groups" : "group"
      } due to a recent issue. To ensure your records remain accurate, this needs to be corrected.`}</p>
      <p>Would you like to fix it now or handle it later?</p>
    </div>
  );
}

export default Step1Details;
